enum AppsEnum {
    edp = 'edp',
    nearMisses = 'near-misses',
    tasks = 'tasks',
    hseActivities = 'hse-activities',
    covid = 'covid',
    remoteInterventions = 'remote-interventions',
    questRegistrations = 'quest-registrations',
    documentsRebranding = 'documents-rebranding',
    home = 'home',
    mfilesDocuments = 'mfiles-documents',
    synergy = 'synergy',
    hierarchy = 'hierarchy',
}

export default AppsEnum;
